import KidsFooterPresentation from 'components/KidsFooter/KidsFooterPresentation'

export default {
  Presentation: KidsFooterPresentation,
}
